import { AxiosResponse } from 'axios';
import { useMutation } from 'react-query';

import { useHttpClient } from '../../../../shared/http/HttpClientProvider';
import { MutationOptions, MutationResult } from '../../../../shared/types/query';

interface DeleteSipUserMutationParams {
  extension: string;
}

export function useDeleteSipUser(options?: MutationOptions<DeleteSipUserMutationParams, AxiosResponse>): MutationResult<DeleteSipUserMutationParams, AxiosResponse> {
  const http = useHttpClient();

  return useMutation({
    ...options,
    mutationKey: ['users/deleteSipUser'],
    mutationFn: ({ extension }) => {
      return http.request({
        method: 'delete',
        url: `SipUser/${extension}`,
      })
    },
  })
}
